import {FC} from 'react';

import {NavigationTabs} from '@mavismart_frontend/components/navigation_tabs';
import {NotificationsList} from '@mavismart_frontend/pages/tabs/notifications_list';
import {NotificationsParams} from '@mavismart_frontend/pages/tabs/notifications_params';

export const NotificationTabs: FC = () => {
  return (
    <NavigationTabs
      tabs={[
        {
          path: '/user/notifications',
          label: 'notifications',
          view: <NotificationsList />,
          default: true,
        },
        {
          path: '/user/settings',
          label: 'settings',
          view: <NotificationsParams />,
        },
      ]}
    />
  );
};

NotificationTabs.displayName = 'NotificationTabs';
